import { useEffect, useRef } from "react"

function useTilt(active) {
	const ref = useRef(null)

	useEffect(() => {
		if (!ref.current || !active) {
			return
		}

		const state = {
			rect: undefined,
			mouseX: undefined,
			mouseY: undefined,
		}

		let el = ref.current

		const handleMouseMove = (e) => {
			if (!el) {
				return
			}
			if (!state.rect) {
				state.rect = el.getBoundingClientRect()
			}
			state.mouseX = e.clientX
			state.mouseY = e.clientY
			const px = (state.mouseX - state.rect.left) / state.rect.width
			const py = (state.mouseY - state.rect.top) / state.rect.height

			el.style.setProperty("--px", px)
			el.style.setProperty("--py", py)
		}

		el.addEventListener("mousemove", handleMouseMove)

		return () => {
			el.removeEventListener("mousemove", handleMouseMove)
		}
	}, [active])

	return ref
}

export default useTilt
